import {persistUtmCookie as persistSharedUtmCookie} from '@teladoc/fe-ccm/ui/common/utilities/url-utils';

export const persistUtmCookie = persistSharedUtmCookie;

const UrlUtils = {
    persistUtmCookie,
};

export default UrlUtils;
